module.exports = __webpack_public_path__ + "static/scale-model-of-republic-of-the-rio-grande-museum-in-laredo-texas-37a04cced32fa0cb0fe80656562bf3d3.png";